var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mouseActionContainer",class:{ isDark: _vm.isDark }},[_c('a-tooltip',{staticClass:"item",attrs:{"effect":"dark","title":_vm.useLeftKeySelectionRightKeyDrag
        ? '当前：左键拖动画布，右键框选节点'
        : '当前：左键框选节点，右键拖动画布',"placement":"top"}},[_c('div',{staticClass:"btn iconfont",class:[_vm.useLeftKeySelectionRightKeyDrag ? 'iconmouseR' : 'iconmouseL'],on:{"click":_vm.toggleAction}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }